<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../node_modules/mint-ui/lib/style.css';
@import 'assets/css/border.css';
@import '/assets/scss/theme/customized_mintui';
@import '/assets/scss/global';
* {
  padding: 0;
  margin: 0;
  outline: none;
}
// 清除 a 链接默认样式
a {
  text-decoration: none;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
a:active {
  text-decoration: none;
}
body {
  background-color: #efeff1;
  // 文本不能被选中
  /*-moz-user-select:none;!*火狐*!
  -webkit-user-select:none;!*webkit浏览器*!
  -ms-user-select:none;!*IE10*!
  user-select:none;*/
}
body {
  font-family: 'PingFangSC-Medium', '微软雅黑', sans-serif;
}
li {
  list-style: none;
}
/*未读标记badge*/
.el-badge__content.is-fixed {
  top: 3px;
  right: 0 !important;
}
.cancelButton {
  float: right;
  margin-left: 10px;
}
/*.el-badge__content.is-fixed{
    top:12px;
    right:-3px;
  }
  .el-badge__content{
    font-size:10px;
    width:14px;
    height: 14px;
    line-height: 14px;
    padding: 0;
    border-radius: 50%;
    border: 0;
  }
  .el-badge__content.is-dot{
    width:8px;
    height:8px;
  }*/
html,
body,
#app {
  width: 100%;
  height: 100%;
}
.is-app {
  padding-top: 0 !important;
}
.article-content .image {
  // display: flex;
  img {
    width: 100%;
  }
}
.card {
  .el-card__body {
    padding: 20px 0 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue